import {currentUserMeetsUserLevel} from '@netx/core-user/utils';
import {DOWNLOAD_REQUESTS_MANAGE_MINIMUM_USER_LEVEL} from './constants';

// should we turn this off when download approvals is not setup?
// and if so, do we have all the information needed, for any user level, to determine this?
export const canManageDownloadRequests = () =>
	currentUserMeetsUserLevel(DOWNLOAD_REQUESTS_MANAGE_MINIMUM_USER_LEVEL);
